import enCopyToClipboardTranslationsJson from './en_US.json'

export const enCopyToClipboardTranslations = enCopyToClipboardTranslationsJson
